/**
 * VoicemailEmpty — empty state for the inbox.
 */
import React from 'react';
const CONTAINER_STYLE = {
    textAlign: 'center',
    padding: '60px 20px'
};
const ICON_STYLE = {
    fontSize: 48,
    marginBottom: 16,
    opacity: 0.4,
    color: 'rgba(226, 236, 247, 0.3)'
};
const TITLE_STYLE = {
    fontSize: 18,
    fontWeight: 600,
    color: 'rgba(226, 236, 247, 0.7)',
    marginBottom: 8
};
const VoicemailEmpty = () => (React.createElement("div", { style: CONTAINER_STYLE },
    React.createElement("div", { style: ICON_STYLE }, "\u2709"),
    React.createElement("div", { style: TITLE_STYLE }, "No voicemail messages")));
export default VoicemailEmpty;
